export function shouldSyncNodesBoxTextFromSession(
  objectText: unknown,
  sessionContent: unknown,
): boolean {
  if (!Array.isArray(sessionContent) || sessionContent.length === 0) {
    return false;
  }
  return JSON.stringify(objectText) !== JSON.stringify(sessionContent);
}
